/**
 * lib-blueprint
 *
 * Adapptio library for processing blueprints.
 *
 * @package lib-blueprint
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

/**
 * Invalid model node manipulation
 */
export class ModelNodeManipulationError extends Error {
	public schemaName: string;
	public schemaOpts: unknown;
	public errorMessage: string;

	public constructor(schemaName: string, schemaOpts: unknown, message: string) {
		super(`Can't update model node: ${message}`);

		this.schemaName = schemaName;
		this.schemaOpts = schemaOpts;
		this.errorMessage = message;
	}
}
